import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchBitcoinPrice } from "../api/Bitcoin"; // import API functions

import "./Navbar.css";

function Navbar() {
	const [click, setClick] = useState(false);
	const [price, setPrice] = useState(null);

	const handleClick = () => setClick(!click);
	const closeMobileMenu = () => setClick(false);

	// Fetch Bitcoin data when the component is mounted
	useEffect(() => {
		async function loadBitcoinData() {
			try {
				const priceData = await fetchBitcoinPrice();
				setPrice(priceData);
			} catch (err) {
				// Error handling removed
			}
		}

		loadBitcoinData();
	}, []);

	const { t, i18n } = useTranslation();

	return (
		<>
			<nav className="navbar">
				<div className="navbar-container">
					<Link
						to="/"
						className="navbar-logo"
						onClick={closeMobileMenu}
					>
						<div className="logo-text">21BTC</div>
						<div className="navbar-mobile-rocket">
							<i className="fas fa-rocket"></i>
						</div>
					</Link>
					{price && (
						<div className="navbar-price">
							BTC: ${price.prices.USD}
						</div>
					)}{" "}
					{/* Display live BTC price */}
					<div className="menu-icon" onClick={handleClick}>
						<i className={click ? "fas fa-times" : "fas fa-bars"} />
					</div>
					<ul className={click ? "nav-menu active" : "nav-menu"}>
						<li className="nav-item">
							<Link
								to="/"
								className="nav-links"
								onClick={closeMobileMenu}
							>
								{t("nav1")}
							</Link>
						</li>
						<li className="nav-item">
							<Link
								to="/getting-started"
								id="gettingStarted"
								className="nav-links"
								onClick={closeMobileMenu}
							>
								{t("nav2")}
							</Link>
						</li>

						<li className="nav-item">
							<Link
								to="/resources"
								className="nav-links"
								onClick={closeMobileMenu}
							>
								{t("nav3")}
							</Link>
						</li>

						<li className="nav-item">
							<Link
								to="/white-paper"
								className="nav-links"
								onClick={closeMobileMenu}
							>
								{t("nav4")}
							</Link>
						</li>
					</ul>
					<div>
						<button
							className="translate-button"
							onClick={() => i18n.changeLanguage("is")}
						>
							Íslenska
						</button>
						<button
							className="translate-button"
							onClick={() => i18n.changeLanguage("en")}
						>
							English
						</button>
					</div>
				</div>
			</nav>
		</>
	);
}

export default Navbar;
